<template>
  <div class="wrapper">
    <div class="wrap">
      <div class="conv-wrap">
        <div class="chat-header">我的会话</div>
        <div class="conv-scroll-box">
          <div
            class="flex conversation-item"
            v-for="(item, index) in convList"
            :key="index"
            :class="
              item.imConversationID == currentConversation.imConversationID
                ? 'conv-ac'
                : ''
            "
            @click="changeConv(item)"
          >
            <conversationItem :conversation="item" />
          </div>
        </div>
      </div>
      <div class="chat-wrap">
        <chat :conversation="currentConversation" />
      </div>
      <div class="info-wrap">
        <chatInfo :conversation="currentConversation" />
      </div>
    </div>
  </div>
</template>

<script>
import conversationItem from "./components/conversation/conversation-item/index.vue";
import chat from "./components/chat/index.vue";
import chatInfo from "./components/chat-info/index.vue";
let originalTitle = document.title;
export default {
  name: "timHome",
  components: {
    conversationItem,
    chat,
    chatInfo,
  },
  data() {
    return {
      currentConversation: {},

      form: { nick: "", avatar: "" },
      userInfo: {},
      convList: [],
      IDlist: {},
      userName: {},
      userList: [],
      show: 0,
      updateShow: false,
      managerInfo: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },
  computed: {
    timLogin() {
      return this.$store.state.timLogin;
    },
  },
  mounted() {
    if (this.timLogin) {
      this.handleSDKReady();
    } else {
      this.$store.dispatch("loginTim");
    }

    this.$tim.on(this.$tims.EVENT.SDK_READY, this.handleSDKReady);
    this.$tim.on(
      this.$tims.EVENT.CONVERSATION_LIST_UPDATED,
      this.onConversationListUpdated
    );
  },
  destroyed() {
    sessionStorage.setItem("user", JSON.stringify(this.userInfo));

    this.$tim.off(this.$tims.EVENT.SDK_READY, this.handleSDKReady);
    this.$tim.off(
      this.$tims.EVENT.CONVERSATION_LIST_UPDATED,
      this.onConversationListUpdated
    );
  },
  methods: {
    getLastMag(conversation) {
      if (conversation.lastMessage.payload) {
        if (conversation.lastMessage.payload.data == "order") {
          return "[课程订单]";
        } else if (conversation.lastMessage.payload.data == "need") {
          return "[课程需求]";
        } else if (conversation.lastMessage.payload.data == "group_create") {
          return "[班级创建成功]";
        } else if (conversation.lastMessage.payload.data == "course") {
          return "[课程信息]";
        } else {
          return conversation.lastMessage.messageForShow;
        }
      }
      return "";
    },
    openUpdate() {
      this.form.nick = this.userInfo.nick;
      this.form.avatar = this.userInfo.avatar;
      this.updateShow = true;
    },
    navigateChatUser() {
      if (this.$route.params.user) {
        this.$tim
          .getConversationProfile("C2C" + this.$route.params.user)
          .then((res) => {
            const { conversation } = res.data;
            this.show = 1;
            this.IDlist = conversation;
            this.userName = conversation;
          });
      }
    },
    //获取自己的消息
    getUserInfo() {
      this.$tim.getMyProfile().then((res) => {
        this.userInfo = res.data;
      });
    },
    updateUserInfo() {
      this.$tim
        .updateMyProfile({
          nick: this.form.nick,
          avatar: this.form.avatar,
        })
        .then((res) => {
          this.updateShow = false;
          this.userInfo.nick = this.form.nick;
          this.userInfo.avatar = this.form.avatar;
        });
    },
    // 挂载完毕
    handleSDKReady() {
      this.getUserInfo();
      this.getConversationList();
      this.navigateChatUser();
      // let TM = setTimeout(() => {
      //     this.TimUser()
      //     clearTimeout(TM)
      // }, 1000)
    },
    getConversationList() {
      this.$tim.getConversationList().then((imResponse) => {
        if (imResponse.data.data.conversationList.length > 0) {
          this.convList = imResponse.data.data.conversationList;
        }
      });
    },
    TimUser() {
      if (this.$store.state.TimUser_id) {
        let id = "C2C" + this.$store.state.TimUser_id;
        let list = this.convList.filter((element) => {
          return id == element.conversationID;
        });
        if (list.length) {
          this.show = 1;
          this.IDlist = list[0];
          this.userName = list[0];
          this.$store.commit("SET_TimUser_id", "");
        } else {
          this.$refs.Chatpage.$refs.SendOut.greetsb();
        }
      }
    },

    changeConv(conv) {
      this.currentConversation = conv;
    },
    // 获取列表
    onConversationListUpdated(event) {
      
      this.convList = event.data;
      let n = 0;
      this.convList.forEach((v) => {
        n += v.unreadCount;
      });

      // 确保已获得权限
      if (n > 0 && Notification.permission === "granted") {
        this.$notify.success("会话更新");
        new Notification("你有新消息", {
          body: "用户咨询，请及时回复",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 96%;
  height: calc(100vh - 150px);
  background: #fff;
  border-radius: 10px;
  .wrap {
    display: flex;
    width: 100%;
    height: 100%;
    .conv-wrap {
      width: 280px;
      .conv-scroll-box {
        overflow-y: auto;
        height: calc(100% - 50px);
      }
      .conv-ac {
        background-color: rgb(247, 201, 150);
      }
    }
    .chat-wrap {
      flex: 1;
      border-left: 1px solid #eee;
      border-right: 1px solid #eee;
    }
    .info-wrap {
      width: 300px;
    }
  }
}

.chat-header {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 20px;
  font-size: 15px;
  font-weight: 600;
  border-bottom: 1px solid #eee;
}

.conversation-item:hover {
  background-color: #dff1fc;
}
</style>